import { render, staticRenderFns } from "./HpgsIDCardAlevel.vue?vue&type=template&id=489826f5&scoped=true&"
import script from "./HpgsIDCardAlevel.vue?vue&type=script&lang=js&"
export * from "./HpgsIDCardAlevel.vue?vue&type=script&lang=js&"
import style0 from "./HpgsIDCardAlevel.vue?vue&type=style&index=0&id=489826f5&lang=scss&scoped=true&"
import style1 from "./HpgsIDCardAlevel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489826f5",
  null
  
)

export default component.exports